import { Link, NavLink } from "react-router-dom";
import { navItems } from "../../data/siteData";
import Logo from "../ui/Logo";

function Header() {
  return (
    <header className="sticky top-0 z-40 border-b border-cyan-300/10 bg-[#02070d]/92 backdrop-blur">
      <div className="shell flex h-16 items-center justify-between gap-4">
        <Link to="/" className="text-left">
          <Logo />
        </Link>

        <nav className="hidden items-center gap-1 md:flex">
          {navItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) =>
                `rounded-md px-3 py-2 text-sm font-semibold transition ${
                  isActive
                    ? "bg-cyan-300 text-slate-950"
                    : "text-slate-300 hover:bg-cyan-300/10 hover:text-cyan-100"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden items-center gap-3 md:flex">
          <Link to="/admin" className="text-sm font-semibold text-slate-400 hover:text-cyan-100">
            Prihlaseni
          </Link>
          <Link to="/kontakt" className="btn-primary">
            Poptat praci
          </Link>
        </div>
      </div>

      <div className="shell flex gap-2 overflow-x-auto border-t border-cyan-300/10 py-2 md:hidden">
        {[...navItems, { label: "Login", path: "/admin" }].map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            className={({ isActive }) =>
              `shrink-0 rounded-md px-3 py-2 text-sm font-semibold ${
                isActive ? "bg-cyan-300 text-slate-950" : "bg-cyan-300/5 text-slate-300"
              }`
            }
          >
            {item.label}
          </NavLink>
        ))}
      </div>
    </header>
  );
}

export default Header;
